import { Box, styled, Typography } from '@mui/material';

export const OverlayContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  flex: '1 1 100%',
  width: '100%',
  height: '100%',
  minWidth: 0,
  maxWidth: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  padding: `${theme.spacing(8)} ${theme.spacing(4)}`,
}));

export const BlurredContentContainer = styled(Box)(({ theme }) => ({
  filter: `blur(${theme.spacing(1)})`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  flex: 1,
  overflow: 'hidden',
  '& svg': {
    width: '200px',
    height: 'auto',
    maxWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '350px',
    },
    [theme.breakpoints.up('md')]: {
      width: '390px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '550px',
    },
  },
}));

export const OverlayLabelContainer = styled(Box)<{ top: string }>(
  ({ theme, top }) => ({
    position: 'absolute',
    top: top,
    left: '-5%',
    right: 0,
    transform: 'translateY(-50%) rotate(-6deg)',
    backgroundColor: theme.palette.secondary.main,
    padding: `${theme.spacing(1)} 0`,
    zIndex: theme.zIndex.modal,
    width: '110%',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(1.5)} 0`,
    },
  }),
);

export const OverlayLabelText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold || 600,
  color: theme.palette.text.primary,
  textAlign: 'center',
  fontSize: theme.typography.body1.fontSize,
  letterSpacing: '0.5px',
  lineHeight: 1.2,
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.h6?.fontSize || theme.typography.h6.fontSize,
    letterSpacing: theme.typography.h5?.letterSpacing || '1px',
    lineHeight: theme.typography.h5?.lineHeight || 1.2,
  },
}));
